/* eslint-disable react/prop-types */
import { ICellTextProps } from "ka-table/props";
import React from "react";

/**
 * Custom cell component.
 */
const StatusCell: React.FC<ICellTextProps> = React.memo(
  ({
    column, ...props
  }) => {
    const value = props.rowData[`${column.key}`];
    const normalized = String(value || "").toLowerCase();

    const statusClass = normalized === "error" || normalized === "failed"
      ? "bg-red-50 text-red-700"
      : "bg-gray-100 text-gray-600";

    return (
      <span className={`inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-[5px] ${statusClass}`}>
        {value || "-"}
      </span>
    );
  },
);

export default StatusCell;
